<template>
  <b-modal
    v-if="podeVerRanking"
    id="modal-vinculo-acompanhamento"
    dialog-class="modal-vinculo-aps"
    size="xl"
    hide-footer
    centered
    scrollable
    :title="titulo"
    body-class="p-0"
    v-model="visible"
    @shown="carregar"
    @hidden="$emit('update:show', false)"
  >
    <div class="aps-bg">
      <div class="panel position-relative">
        <div v-if="loading" class="loading-wrap">
          <b-spinner label="Carregando"></b-spinner>
          <div class="mt-2 small text-muted">Carregando indicadores…</div>
        </div>

        <div v-else class="content-wrap">
          <!-- Wrapper que só “ativa” no modo evolução -->
          <div :class="[{ 'wrap-evolucao': modoEvolucao }]">
            <!-- Cabeçalho (modo evolução) - layout -->
            <div v-if="modoEvolucao" class="header-resumo">
              <div class="header-resumo__logo" v-if="municipioLogo">
                <img :src="municipioLogo" alt="Brasão" />
              </div>

              <div class="header-resumo__content">
                <h1 class="header-resumo__title">
                  {{ municipioNomeUf }}
                </h1>

                <div class="header-resumo__badges">
                  <span class="header-resumo__badge">
                    {{ resultadoQuadrimestre }}
                  </span>

                  <span class="header-resumo__meta">
                    <i class="icofont-users-social"></i>
                    {{ totalEquipes }} Equipes avaliadas por indicador
                  </span>
                </div>

                <div class="header-resumo__progress">
                  <div class="header-resumo__progress-top">
                    <span>Com 100% de recursos federais na APS</span>
                    <span
                      class="header-resumo__progress-val"
                      :style="{ color: barFillColor }"
                    >
                      {{ percentualOtimas }}% das equipes
                    </span>
                  </div>

                  <div class="header-resumo__bar">
                    <div
                      class="header-resumo__bar-fill"
                      :style="{
                        width: percentualOtimas + '%',
                        background: barFillColor,
                      }"
                    ></div>
                  </div>
                </div>
              </div>

              <div class="header-resumo__actions">
                <button
                  class="header-resumo__btn header-resumo__btn--primary"
                  @click="abrirEvolucao"
                >
                  <i class="icofont-chart-histogram"></i>
                  Evolução
                </button>

                <button
                  class="header-resumo__btn header-resumo__btn--light"
                  @click="abrirPodio"
                >
                  <i class="icofont-trophy"></i>
                  Pódio
                </button>

                <button
                  class="header-resumo__btn header-resumo__btn--light"
                  @click="imprimirDados"
                >
                  <i class="icofont-print"></i>
                  Print
                </button>
              </div>
            </div>

            <div v-if="!modoEvolucao" class="actions-float">
              <div class="d-flex justify-content-end mb-3">
                <b-dropdown
                  right
                  variant="light"
                  toggle-class="btn-aps-actions"
                  no-caret
                >
                  <template #button-content>
                    <i class="icofont-navigation-menu"></i>
                  </template>

                  <b-dropdown-item @click="abrirPodio">
                    <i class="icofont-trophy mr-2"></i>
                    Pódio
                  </b-dropdown-item>

                  <b-dropdown-item
                    @click="$refs.modalInfoIndicadores.modalShow = true"
                  >
                    <i class="icofont-question-circle mr-2"></i>
                    Ajuda
                  </b-dropdown-item>

                  <b-dropdown-item @click="abrirEvolucao">
                    <i class="icofont-chart-histogram mr-2"></i>
                    Evolução
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>

            <modal-informacao
              ref="modalInfoIndicadores"
              :isIframe="true"
              buttonTemplate="none"
              urlIframe="https://esus-feedback.gitbook.io/esus-feedback/indicadores-aps/resultado-municipal"
              pageIdentifier="indicadores-aps-resultado-municipal"
            ></modal-informacao>

            <!-- PODIUM -->
            <div
              class="podium-section"
              v-if="
                !modoEvolucao && (podium.first || podium.second || podium.third)
              "
            >
              <!-- <div class="section-title">Em destaque nesse momento</div> -->

              <div class="podium-container">
                <!-- 2º lugar -->
                <div v-if="podium.second" class="podium-step second">
                  <div class="medal-icon">🥈</div>
                  <div class="team-name">{{ podium.second.ubs }}</div>
                  <div class="team-name">{{ podium.second.nome }}</div>
                  <div class="team-type">{{ podium.second.tipo }}</div>
                </div>

                <!-- 1º lugar -->
                <div v-if="podium.first" class="podium-step first">
                  <div class="crown-icon">👑</div>
                  <div class="medal-icon">🥇</div>
                  <div class="team-name">{{ podium.first.ubs }}</div>
                  <div class="team-name">{{ podium.first.nome }}</div>
                  <div class="team-type">{{ podium.first.tipo }}</div>
                </div>

                <!-- 3º lugar -->
                <div v-if="podium.third" class="podium-step third">
                  <div class="medal-icon">🥉</div>
                  <div class="team-name">{{ podium.third.ubs }}</div>
                  <div class="team-name">{{ podium.third.nome }}</div>
                  <div class="team-type">{{ podium.third.tipo }}</div>
                </div>
              </div>
            </div>

            <!-- CARDS DE CLASSIFICAÇÃO -->
            <!-- <div class="section-title section-title-bottom">
            Equipes por classificação
          </div> -->

            <div
              class="stats-grid"
              :class="{ 'stats-grid--evolucao': modoEvolucao }"
            >
              <div
                v-for="card in cards"
                :key="card.key"
                v-if="!modoEvolucao || totalEquipesCard(card) > 0"
                class="stat-card"
                :class="card.key"
              >
                <div class="card-header">
                  <span class="card-emoji">
                    <span v-if="totalEquipesCard(card) !== 0">
                      {{ card.emoji }}
                    </span>
                    <span v-else>🎉</span>
                  </span>
                  <span class="card-label"
                    >{{ cardHeaderName(card.key) }}
                  </span>
                  <span
                    class="card-total"
                    :class="{
                      'card-total--success': totalEquipesCard(card) === 0,
                    }"
                  >
                    {{ totalEquipesCard(card) }} Equipes
                  </span>
                </div>

                <div class="card-body">
                  <!-- Quando todas as equipes já superaram a etapa -->
                  <template v-if="canShowAllDone(card.key)">
                    <div class="all-done-wrap">
                      <div class="all-done-icon">
                        <i class="icofont-check"></i>
                      </div>
                      <div class="all-done-text">
                        Etapa superada por todas as equipes!
                      </div>
                    </div>
                  </template>

                  <!-- Quando ainda existem equipes na etapa -->
                  <template v-else>
                    <div
                      v-for="m in card.metrics"
                      :key="m.label"
                      v-if="m.value > 0"
                      class="metric-row"
                      @click="abrirModalEquipes(card.key, m.label, m.value)"
                    >
                      <span class="metric-name">
                        <span v-if="m.isUserEquipe" class="user-team-emoji"
                          >👋</span
                        >
                        {{ m.label }}
                        <span
                          v-b-tooltip.html.hover
                          :title="metricTooltip(m.label)"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </span>
                      <span class="metric-val">{{ m.value }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Equipes -->
    <b-modal
      id="modal-lista-equipes"
      size="xl"
      hide-footer
      centered
      v-model="modalEquipes.visible"
      body-class="p-0"
    >
      <template #modal-title>
        <span v-html="modalEquipes.titulo"></span>
        <span class="tag-indicador">{{ mesQuadrimestre }}</span>
      </template>
      <div class="p-3">
        <div v-if="modalEquipes.loading" class="text-center my-4">
          <b-spinner small></b-spinner>
          <div class="small text-muted mt-2">Carregando equipes…</div>
        </div>

        <div v-else>
          <div
            v-if="!modalEquipes.items.length"
            class="text-muted text-center py-4"
          >
            Nenhuma equipe encontrada.
          </div>

          <!-- QUANDO NÃO FOR CVAT -->
          <div v-else-if="modalEquipes.tipo !== 'CVAT'">
            <EquipesDataTable
              :items="modalEquipes.items"
              :loading="modalEquipes.loading"
            />
          </div>
          <div v-else class="table-responsive">
            <CvatDataTable
              :items="modalEquipes.items"
              :loading="modalEquipes.loading"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import EquipesDataTable from './EquipesDataTable.vue'
import CvatDataTable from './CvatDataTable.vue'
import ModalInformacao from '@/components/ModalInformacao.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'IndicadoresApsModal',
  components: { EquipesDataTable, CvatDataTable, ModalInformacao },
  props: {
    titulo: { type: String, default: '' },
    show: { type: Boolean, default: false },
  },
  mixins: [utils],
  data() {
    return {
      visible: this.show,
      loading: true,
      cabecalhoMes: '',
      cards: [],
      totalEquipes: 0,
      dataRaw: [],
      podium: {
        first: null,
        second: null,
        third: null,
      },
      modalEquipes: {
        visible: false,
        loading: false,
        titulo: '',
        tipo: '',
        items: [],
      },
      modoEvolucao: false,
    }
  },
  computed: {
    podeVerRanking() {
      let idFuncaoPodeVer = ['1', '2', '9', '10', '11', '12', '13', '15']

      if (idFuncaoPodeVer.includes(this.$store.state.id_funcao)) {
        return true
      }

      const permissoes = this.$store.state.permissoes || {}
      const dashboard = permissoes.dashboard || []

      const perm = dashboard.find(
        (p) => p.key === 'modal_ranking_indicadores_aps'
      )
      if (perm == undefined) {
        return false
      }

      return perm.ativo == 1
    },

    municipioNomeUf() {
      return this.$store.state.cidade || ''
    },

    municipioLogo() {
      const brasao = this.$store.state?.infoMunicipio?.brasao

      if (!brasao) {
        return require('@/assets/images/logo.png')
      }

      return `https://esusfeedback.com.br${brasao}`
    },

    resultadoQuadrimestre() {
      let datas = this.datasQuadrimestre()
      let ano = datas.data_inicio.split('-')[0]
      let quad = datas.quadrimestre
      return `RESULTADO ${ano} Q${quad}`
    },

    mesQuadrimestre() {
      let datas = this.datasQuadrimestre()
      let mes = new Date().getMonth() + 1
      let ano = new Date().getFullYear()
      return `${mes}/${ano}`
    },

    percentualOtimas() {
      const total = Number(this.totalEquipes || 0)
      if (!total) return 0

      const cardOtima = (this.cards || []).find((c) => c.key === 'otima')
      const otimas = this.totalEquipesCard(cardOtima)

      return Math.round((otimas / total) * 100)
    },

    barFillColor() {
      const p = Number(this.percentualOtimas || 0)

      if (p <= 25) return '#C46500'
      if (p > 25 && p <= 50) return '#D5BA0A'
      if (p > 50 && p <= 75) return '#38BA38'
      return '#1212B6'
    },
  },
  watch: {
    show(val) {
      if (val && !this.podeVerRanking) {
        this.visible = false
        this.$emit('update:show', false)
        return
      }
      this.visible = val
    },
    visible(val) {
      this.$emit('update:show', val)
    },
  },
  methods: {
    async carregar() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/indicadores-aps/resultado-indicadores/' +
            this.$store.state.cod_ibge
        )

        if (response) {
          this.dataRaw = Array.isArray(response.data) ? response.data : []
          this.prepararCards(this.dataRaw)
          this.montarPodio()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    prepararCards(data) {
      // Cabeçalho (mês atual)
      const hoje = new Date()
      const nomeMes = hoje.toLocaleString('pt-BR', { month: 'long' })
      const mesAnoAtual =
        nomeMes.charAt(0).toUpperCase() +
        nomeMes.slice(1) +
        ' ' +
        hoje.getFullYear()
      this.cabecalhoMes = mesAnoAtual

      const acc = {
        regular: { eMulti: 0, eSB: 0, eSF: 0, CVAT: 0 },
        suficiente: { eMulti: 0, eSB: 0, eSF: 0, CVAT: 0 },
        boa: { eMulti: 0, eSB: 0, eSF: 0, CVAT: 0 },
        otima: { eMulti: 0, eSB: 0, eSF: 0, CVAT: 0 },
      }

      const userHighlight = {
        regular: { eMulti: false, eSB: false, eSF: false, CVAT: false },
        suficiente: { eMulti: false, eSB: false, eSF: false, CVAT: false },
        boa: { eMulti: false, eSB: false, eSF: false, CVAT: false },
        otima: { eMulti: false, eSB: false, eSF: false, CVAT: false },
      }

      const clsMap = {
        Regular: 'regular',
        Suficiente: 'suficiente',
        Bom: 'boa',
        Ótimo: 'otima',
        Otimo: 'otima',
      }

      const nu_ine = this.$store.state.nu_ine

      data.forEach((row) => {
        const clsKey = clsMap[row.classificacao]
        const tipoKey = row.tp_indicador // 'eMulti', 'eSB', 'eSF', 'CVAT'
        const qtd = Number(row.qtd_equipes || 0)

        if (clsKey && acc[clsKey] && tipoKey && acc[clsKey][tipoKey] != null) {
          acc[clsKey][tipoKey] += qtd
        }

        if (
          nu_ine != null &&
          clsKey &&
          tipoKey &&
          userHighlight[clsKey] &&
          userHighlight[clsKey][tipoKey] !== undefined
        ) {
          const equipes = this._parseEquipes(row.equipes)
          const equipe = equipes.find((el) => el.ine == nu_ine)
          if (equipe) {
            userHighlight[clsKey][tipoKey] = true
          }
        }
      })

      this.totalEquipes = data.reduce(
        (s, r) => s + (Number(r.qtd_equipes) || 0),
        0
      )

      this.cards = [
        {
          key: 'otima',
          emoji: '🏆',
          metrics: [
            {
              label: 'eSF',
              value: acc.otima.eSF,
              isUserEquipe: userHighlight.otima.eSF,
            },
            {
              label: 'eSB',
              value: acc.otima.eSB,
              isUserEquipe: userHighlight.otima.eSB,
            },
            {
              label: 'eMulti',
              value: acc.otima.eMulti,
              isUserEquipe: userHighlight.otima.eMulti,
            },
            {
              label: 'CVAT',
              value: acc.otima.CVAT,
              isUserEquipe: userHighlight.otima.CVAT,
            },
          ],
        },
        {
          key: 'boa',
          emoji: '👍',
          metrics: [
            {
              label: 'eSF',
              value: acc.boa.eSF,
              isUserEquipe: userHighlight.boa.eSF,
            },
            {
              label: 'eSB',
              value: acc.boa.eSB,
              isUserEquipe: userHighlight.boa.eSB,
            },
            {
              label: 'eMulti',
              value: acc.boa.eMulti,
              isUserEquipe: userHighlight.boa.eMulti,
            },
            {
              label: 'CVAT',
              value: acc.boa.CVAT,
              isUserEquipe: userHighlight.boa.CVAT,
            },
          ],
        },
        {
          key: 'suficiente',
          emoji: '😐',
          metrics: [
            {
              label: 'eSF',
              value: acc.suficiente.eSF,
              isUserEquipe: userHighlight.suficiente.eSF,
            },
            {
              label: 'eSB',
              value: acc.suficiente.eSB,
              isUserEquipe: userHighlight.suficiente.eSB,
            },
            {
              label: 'eMulti',
              value: acc.suficiente.eMulti,
              isUserEquipe: userHighlight.suficiente.eMulti,
            },
            {
              label: 'CVAT',
              value: acc.suficiente.CVAT,
              isUserEquipe: userHighlight.suficiente.CVAT,
            },
          ],
        },
        {
          key: 'regular',
          emoji: '😟',
          metrics: [
            {
              label: 'eSF',
              value: acc.regular.eSF,
              isUserEquipe: userHighlight.regular.eSF,
            },
            {
              label: 'eSB',
              value: acc.regular.eSB,
              isUserEquipe: userHighlight.regular.eSB,
            },
            {
              label: 'eMulti',
              value: acc.regular.eMulti,
              isUserEquipe: userHighlight.regular.eMulti,
            },
            {
              label: 'CVAT',
              value: acc.regular.CVAT,
              isUserEquipe: userHighlight.regular.CVAT,
            },
          ],
        },
      ]
    },

    montarPodio() {
      // 1º: Ótimo
      this.podium.first =
        this.sortearEquipePorClassificacao('Ótimo') ||
        this.sortearEquipePorClassificacao('Otimo') ||
        null

      // 2º: Bom
      this.podium.second = this.sortearEquipePorClassificacao('Bom')

      // 3º: Suficiente
      this.podium.third = this.sortearEquipePorClassificacao('Suficiente')
    },

    sortearEquipePorClassificacao(classificacaoAlvo) {
      if (!Array.isArray(this.dataRaw) || !this.dataRaw.length) return null

      const equipes = []

      this.dataRaw.forEach((row) => {
        if (row.classificacao !== classificacaoAlvo) return

        const tipoRow = row.tp_indicador === 'CVAT' ? 'CVAT' : row.tp_indicador
        const arr = this._parseEquipes(row.equipes)
        arr.forEach((eq) => {
          equipes.push({
            nome: eq.no_equipe,
            ubs: eq.no_ubs,
            tipo: tipoRow,
            classificacao: classificacaoAlvo,
          })
        })
      })

      if (!equipes.length) return null

      const idx = Math.floor(Math.random() * equipes.length)
      return equipes[idx]
    },

    totalEquipesCard(card) {
      if (!card || !Array.isArray(card.metrics)) return 0
      return card.metrics.reduce((s, m) => s + (Number(m.value) || 0), 0)
    },

    metricTooltip(label) {
      const map = {
        eMulti: 'Classificação nos 2 Indicadores eMulti',
        eSB: 'Classificação nos 6 Indicadores eSB',
        eSF: 'Classificação nos 7 Indicadores eSF / eAP',
        CVAT: 'Classificação no Componente Vínculo e Acompanhamento Territorial',
      }
      return map[label] || ''
    },

    async abrirModalEquipes(cardKey, tipoLabel, count) {
      if (!count) return
      this.modalEquipes.visible = true
      this.modalEquipes.loading = true
      this.modalEquipes.items = []
      this.modalEquipes.tipo = this._mapTipoLabelToKey(tipoLabel)

      try {
        const cls = this._mapKeyToClassificacao(cardKey)
        const tipo = this._mapTipoLabelToKey(tipoLabel)

        this.modalEquipes.titulo = `${cls} <span class="tag-indicador">${tipoLabel}</span>`

        const items = this.coletarEquipes(this.dataRaw, cls, tipo)
        this.modalEquipes.items = items
      } catch (e) {
        console.error(e)
      } finally {
        this.modalEquipes.loading = false
      }
    },

    coletarEquipes(dataArray, classificacaoAlvo, tipoAlvo) {
      const out = []
      if (!Array.isArray(dataArray)) return out

      dataArray.forEach((row) => {
        if (row.classificacao !== classificacaoAlvo) return

        const tipoRow = row.tp_indicador === 'CVAT' ? 'CVAT' : row.tp_indicador
        if (tipoRow !== tipoAlvo) return

        const arr = this._parseEquipes(row.equipes)
        arr.forEach((eq) => out.push(eq))
      })

      return out
    },

    _parseEquipes(payload) {
      try {
        if (!payload) return []
        const arr = typeof payload === 'string' ? JSON.parse(payload) : payload
        return Array.isArray(arr) ? arr : []
      } catch (e) {
        console.warn('Falha ao parsear equipes:', e)
        return []
      }
    },

    _mapKeyToClassificacao(key) {
      const map = {
        regular: 'Regular',
        suficiente: 'Suficiente',
        boa: 'Bom',
        otima: 'Ótimo',
      }
      return map[key] || 'Regular'
    },

    _mapTipoLabelToKey(label) {
      if (label === 'CVAT') return 'CVAT'
      if (label === 'eMulti') return 'eMulti'
      if (label === 'eSB') return 'eSB'
      if (label === 'eSF') return 'eSF'
      return label
    },

    cardHeaderName(key) {
      const map = {
        regular: 'REGULARES',
        suficiente: 'SUFICIENTES',
        boa: 'BOAS',
        otima: 'ÓTIMAS',
      }
      return map[key] || 'Regular'
    },

    abrirEvolucao() {
      this.modoEvolucao = true
    },

    abrirPodio() {
      this.modoEvolucao = false
    },

    imprimirDados() {
      this.$nextTick(() => {
        window.print()
      })
    },

    canShowAllDone(cardKey) {
      const ordem = ['regular', 'suficiente', 'boa', 'otima']
      const indexAtual = ordem.indexOf(cardKey)

      if (indexAtual === -1) return false

      return ordem.slice(0, indexAtual + 1).every((key) => {
        const card = this.cards.find((c) => c.key === key)
        return this.totalEquipesCard(card) === 0
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.aps-bg {
  padding: 24px;
  // background-color: #f0f2f5;
}

.panel {
  // background: #ffffff;
  padding: 20px;
  // border-radius: 24px;
  // box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  animation: fadeIn 0.5s ease;
}

.loading-wrap {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.wrap-evolucao {
  width: 100%;
  margin: 0 auto;
  max-width: 900px;
}

.stats-grid--evolucao {
  justify-content: center;
}

.wrap-evolucao .header-resumo,
.wrap-evolucao .stats-grid {
  width: 100%;
  box-sizing: border-box;
}

.header-resumo {
  background: #fff;
  border-radius: 28px;
  padding: 24px;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);

  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;

  flex-wrap: wrap;

  @media screen and (max-width: 656px) {
    flex-direction: column;
  }
  @media screen and (min-width: 657px) and (max-width: 807px) {
    flex-direction: column;
  }
}

.header-resumo__logo {
  flex: 0 0 auto;

  img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    border-radius: 24px;
    border: 2px solid rgba(0, 0, 0, 0.03);
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.08);
    background: #fff;
    display: block;
    padding: 10px;
  }
}

.header-resumo__content {
  flex: 1 1 320px;
  min-width: 260px;
  @media screen and (max-width: 656px) {
    flex: 1 1 auto;
    min-width: auto;
  }
  @media screen and (min-width: 657px) and (max-width: 807px) {
    flex: 1 1 auto;
    min-width: auto;
  }
}

.header-resumo__title {
  font-weight: 900;
  color: #1f2937;
  text-transform: uppercase;
  letter-spacing: -0.4px;
  margin: 0 0 8px 0;
  font-size: 22px;
}

.header-resumo__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 14px;
}

.header-resumo__badge {
  background: rgba(99, 102, 241, 0.12);
  color: #4f46e5;
  padding: 6px 10px;
  border-radius: 10px;
  font-weight: 900;
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.header-resumo__meta {
  color: #9ca3af;
  font-weight: 800;
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  i {
    font-size: 13px;
  }
}

.header-resumo__progress {
  max-width: 520px;
  @media screen and (max-width: 656px) {
    width: 100%;
  }
}

.header-resumo__progress-top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 6px;
}

.header-resumo__progress-val {
}

.header-resumo__bar {
  height: 12px;
  width: 100%;
  background: #f3f4f6;
  border-radius: 999px;
  overflow: hidden;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.06);
}

.header-resumo__bar-fill {
  height: 100%;
  transition: width 0.6s ease;
}

.header-resumo__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: auto;
  @media screen and (max-width: 656px) {
    margin-left: initial;
    flex-direction: row;
  }
  @media screen and (min-width: 657px) and (max-width: 807px) {
    margin-left: initial;
    flex-direction: row;
  }
}

.header-resumo__btn {
  padding: 8px 14px;
  border-radius: 14px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  border: none;
}

.header-resumo__btn i {
  font-size: 14px;
}

.header-resumo__btn--light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.header-resumo__btn--light:hover {
  background: #f8fafc;
}

.header-resumo__btn--primary {
  background: #4f46e5;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.35);
}

.header-resumo__btn--primary:hover {
  background: #4338ca;
}

.header-indicadores {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 40px;
  text-align: center;
}

.municipio-logo {
  max-height: 120px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.municipio-nome {
  font-weight: 900;
  font-size: 26px;
  color: #333;
}

.month-badge {
  display: inline-block;
  background: linear-gradient(135deg, #1e88e5 0%, #0d47a1 100%);
  color: #fff;
  padding: 10px 26px;
  border-radius: 30px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.section-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 24px;
  font-weight: 800;
  position: relative;
  display: inline-block;
  padding-bottom: 12px;
  padding-left: 0;
  background-color: transparent;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.section-title-bottom {
  margin-top: 10px;
}

/* PODIUM */

.podium-section {
  margin: 0 0 40px 0;
  animation: fadeInUp 0.8s ease;
}

.podium-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 300px;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.podium-step {
  width: 200px;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 25px;
  color: #fff;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  // cursor: pointer;
  text-align: center;
}

.podium-step:hover {
  transform: translateY(-10px) scale(1.05);
}

.podium-step.first {
  height: 100%;
  background: linear-gradient(135deg, #ffd700, #ffa500);
  z-index: 3;
  order: 2;
  animation: popIn 0.6s ease 0.2s both;
}

.podium-step.second {
  height: 85%;
  // background: linear-gradient(135deg, #c0c0c0, #e8e8e8);
  background: #c0c0c0;
  z-index: 2;
  order: 1;
  animation: popIn 0.6s ease 0.4s both;
}

.podium-step.third {
  height: 70%;
  background: linear-gradient(135deg, #cd7f32, #a0522d);
  z-index: 1;
  order: 3;
  animation: popIn 0.6s ease 0.6s both;
}

.crown-icon {
  font-size: 48px;
  position: absolute;
  top: -60px;
  animation: float 3s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

.medal-icon {
  font-size: 42px;
  margin-bottom: 12px;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
  animation: spin 4s linear infinite;
}

.team-name {
  font-weight: 900;
  font-size: 13px;
  line-height: 1.3;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.podium-step.first .team-name {
  font-size: 17px;
}

.podium-step.second .team-name {
  font-size: 15px;
}

.podium-step.third .team-name {
  font-size: 13px;
}

.team-type {
  background: rgba(255, 255, 255, 0.3);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
  backdrop-filter: blur(10px);
}

/* CARDS */

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 25px;
  animation: fadeInUp 1s ease;
}

.stats-grid--evolucao {
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  justify-content: center;
  gap: 18px;
  @media screen and (max-width: 656px) {
    grid-template-columns: repeat(1, minmax(260px, 1fr));
  }
}

.stat-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 2px solid transparent;
  position: relative;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  transition: height 0.3s ease;
  pointer-events: none;
}

.stat-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
}

.stat-card:hover::before {
  height: 100%;
  opacity: 0.05;
}

.stat-card.otima::before {
  background: #1212b6;
}
.stat-card.boa::before {
  background: #38ba38;
}
.stat-card.suficiente::before {
  background: #d5ba0a;
}
.stat-card.regular::before {
  background: #c46500;
}

.card-header {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(118, 75, 162, 0.1) 100%
  );
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.card-emoji {
  font-size: 20px;
  animation: bounce 2s ease infinite;
}

.card-label {
  font-weight: 800;
  color: #333;
  font-size: 15px;
  letter-spacing: 1px;
}

.card-label__subtitle {
  flex: 0 0 100%;
  margin-top: 6px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.35;
}

.card-total {
  margin-left: auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 900;
  font-size: 14px;
}

.metric-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
}

.metric-row:last-child {
  border-bottom: none;
}

.metric-row:hover {
  background: linear-gradient(
    90deg,
    rgba(102, 126, 234, 0.05) 0%,
    transparent 100%
  );
  padding-left: 30px;
}

.metric-name {
  color: #666;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: help;
  position: relative;
  transition: all 0.3s ease;
}

.info-icon:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.metric-val {
  color: #333;
  font-weight: 900;
  font-size: 20px;
  transition: all 0.3s ease;
}

.metric-row:hover .metric-val {
  color: #667eea;
  transform: scale(1.1);
}

.card-total--success {
  background: #1212b6; // verde
}

.all-done-wrap {
  padding: 24px 20px;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.all-done-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #2e7d32;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 22px;
}

.all-done-text {
  font-weight: 600;
  font-size: 14px;
  color: #2e7d32;
}

.actions-float {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 50;
}

@media (max-width: 768px) {
  .actions-float {
    top: 12px;
    right: 12px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes popIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(50px);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(-5deg);
  }
  50% {
    transform: translateY(-15px) rotate(5deg);
  }
}

@keyframes spin {
  0%,
  90% {
    transform: rotateY(0deg);
  }
  95% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@media (max-width: 768px) {
  .panel {
    padding: 24px 18px;
  }

  .podium-container {
    height: auto;
    flex-direction: column;
  }

  .podium-step {
    width: 100%;
    height: 150px !important;
    order: 0 !important;
  }

  .crown-icon {
    top: -50px;
    font-size: 40px;
  }
}

@media (max-width: 656px) {
  .podium-step {
    width: 100%;
    height: auto !important;
    order: 0 !important;
  }
}
</style>

<style scoped>
::v-deep .modal-vinculo-aps {
  max-width: 1400px;
}
@media (max-width: 768px) {
  ::v-deep .modal-vinculo-aps {
    max-width: 100%;
  }
}
</style>

<style>
#modal-lista-equipes .tag-indicador {
  background: #d6d2d2;
  color: #000;
  padding: 5px 10px;
  border-radius: 32px;
  font-size: 13px;
  margin-left: 5px;
  font-weight: 700;
}
</style>

<style>
@media print {
  /* Força imprimir cores */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Página branca */
  html,
  body {
    background: #fff !important;
  }

  /* Remove o "cinza" do Bootstrap e padding do modal-open */
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  #modal-vinculo-acompanhamento,
  #modal-vinculo-acompanhamento .modal-content,
  #modal-vinculo-acompanhamento .modal-body,
  #modal-vinculo-acompanhamento .aps-bg,
  #modal-vinculo-acompanhamento .panel,
  #modal-vinculo-acompanhamento .stats-grid {
    background: #fff !important;
    overflow: visible !important;
  }

  /* Mostra apenas o modal e seus filhos */
  #modal-vinculo-acompanhamento,
  #modal-vinculo-acompanhamento * {
    visibility: visible !important;
  }

  /* mata o "centrado" do Bootstrap  */
  #modal-vinculo-acompanhamento .modal-dialog-centered {
    display: block !important;
    align-items: flex-start !important;
    min-height: 0 !important;
  }

  /* garante que o container do modal não seja flex/centralizado */
  #modal-vinculo-acompanhamento.modal {
    display: block !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    padding: 0 !important;
  }

  /* Garante que o modal ocupe a página inteira e não corte conteúdo */
  #modal-vinculo-acompanhamento .modal-dialog {
    margin: 0 !important;
    transform: none !important;
    position: static !important;
    top: 0 !important;
    left: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  #modal-vinculo-acompanhamento .modal-content {
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  #modal-vinculo-acompanhamento .modal-body {
    overflow: visible !important;
    max-height: none !important;
  }

  /* Se não quiser imprimir botões/ações */
  #modal-vinculo-acompanhamento .header-resumo__actions,
  #modal-vinculo-acompanhamento .actions-float {
    display: none !important;
  }

  #modal-vinculo-acompanhamento .close,
  #modal-vinculo-acompanhamento button.close,
  #modal-vinculo-acompanhamento .modal-header {
    display: none !important;
  }

  /* reforça o shadow no print */
  #modal-vinculo-acompanhamento .header-resumo {
    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid rgba(0, 0, 0, 0.06) !important;
    background: #fff !important;
  }

  /* opcional: evita que o browser “apague” efeitos */
  #modal-vinculo-acompanhamento .header-resumo,
  #modal-vinculo-acompanhamento .stat-card,
  #modal-vinculo-acompanhamento .podium-step {
    -webkit-filter: none !important;
    filter: none !important;
  }

  /* Reforça o box-shadow dos cards */
  #modal-vinculo-acompanhamento .stat-card {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid rgba(0, 0, 0, 0.06) !important;
    background: #fff !important;
  }

  /* Evita transform quebrar sombra no print */
  #modal-vinculo-acompanhamento .stat-card {
    transform: none !important;
  }

  .b24-widget-button-visible {
    visibility: hidden !important;
  }
}
</style>
